export default function toggleArrayItem<T>(item: T, items: Array<T>) {
  if (items.includes(item)) {
    return items.filter((arrayItem) => arrayItem !== item);
  } else {
    return [...items, item];
  }
}

export function toggleArrayObject<T>(item: T, key: keyof T, items: Array<T>) {
  const isInArray = !!items.find((arrayItem) => item[key] === arrayItem[key]);

  if (isInArray) {
    return items.filter((arrayItem) => arrayItem[key] !== item[key]);
  } else {
    return [...items, item];
  }
}
